<template>
  <div class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-4 is-12-xs">
          <h1>My account</h1>
          <b-field label="First Name">
            <b-input type="text" placeholder="First name" v-model="user.FirstName"></b-input>
          </b-field>
          <b-field label="Last Name">
            <b-input type="text" placeholder="Last name" v-model="user.LastName"></b-input>
          </b-field>

          <b-field label="Change password">
            <b-input type="password" placeholder="Change password (not required)" v-model="newPassword"></b-input>
          </b-field>

          <b-button class="is-primary" @click="changeInfo">Update</b-button>
        </div>
      </div>
      <div>
        <div v-if="$store.getters.isGroupManager">
          <subscriptions :loading="loading" :data="paymentDetails.Subscriptions"></subscriptions>
        </div>
        <div v-if="!$store.getters.isGroupManager">
          <b-notification :active="IsACCExpired" type="is-danger" v-if="LastPayment">
            Your access to the Carbon Calculator has expired. The last payment was made by {{LastPayment.User}} on {{$moment.utc(LastPayment.LastPaymentOn) | moment("M/DD/YYYY")}}.<br />
            You can contact them at {{LastPayment.Subscriber}}
          </b-notification>
          <b-notification :active="IsACCExpired" type="is-danger" v-if="!LastPayment">
            Your access to the AWG Carbon Calculator has expired.
          </b-notification>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import roles from "@/roles";
  import subscriptionComponent from "@/components/user/paymentDetails/subscriptions";
  export default {
    data() {
      return {
        loading: true,
        paymentDetails: {},
        user: {},
        newPassword: ""
      }
    },
    components: {
      "subscriptions": subscriptionComponent
    },
    computed: {
      IsACCExpired() {
        return this.$store.getters.user.ExpiredRoles.some(role => role === roles.ACCFullAccess);
      },
      LastPayment() {
        if (this.paymentDetails.Subscriptions && this.paymentDetails.Subscriptions.length > 0)
          return this.paymentDetails.Subscriptions[0];
        else
          return null
      }
    },
    methods: {
      async getUser() {
        await this.$http.get("api/user/" + this.$store.getters.user.Id)
          .then(resp => {
            this.user = resp.data;
          }).catch(err => {
            console.error(err);
          })
      },
      async changeInfo() {
        if (this.user.FirstName && this.user.LastName) {
          await this.$http.post("api/user/account", { user: { Id: this.user.Id, FirstName: this.user.FirstName, LastName: this.user.LastName }, newPassword: this.newPassword })
            .then(resp => {
              this.$buefy.notification.open({ message: resp.data });
              this.$store.dispatch("updateName", { FirstName: this.user.FirstName, LastName: this.user.LastName });
            }).catch(err => {
              console.error(err);
            });
        }
        else {
          this.$buefy.notification.open({ message: "Please fill out a First and Last Name.", type: "is-danger" });
        }
      },
      async GetPaymentDetails() {
        try {
          var response = await this.$http.get("/api/user/paymentDetails");
          this.paymentDetails = response.data;
        }
        catch (err) {
          this.error = true;
          console.error(err);
        }
      },
      async CheckPayments() {
        try {
          var response = await this.$http.get("/api/user/check/payments/acc");
          this.paymentDetails = response.data;
        }
        catch (err) {
          this.error = true;
          console.error(err);
        }
      },
    },
    async created() {
      await this.getUser();
    },
    async mounted() {
      if (this.$store.getters.isGroupManager) {
        await this.GetPaymentDetails();
      }
      else {
        await this.CheckPayments();
      }
      this.loading = false;
    }
  }
</script>
